import { DeviceParam, Login, xf, download, GetProjectList, smartstatus, getAqi, AreaXF, martmodel, DeviceType, eDev, DeviceLogList, IpDeviceList, getDevicebrand, reToken, ProAreaList, getALog, AreaInfoFirst, AreaInfo, DeviceList, DeviceLog, Area, EArea, DArea, ProjectDev, addDev, delDev } from '../../api/api.js'
const module1 = {
  state: {
    isChina: true,
    isAir: false,
    showDb: false,
    user: null,
    U: [
      {
        name: 'PM2.5',
        unit: 'μg/m³'
      },
      {
        name: 'TVOC',
        unit: 'ppb'
      },
      {
        name: 'HCHO',
        unit: 'ppb'
      },
      {
        name: 'PM10',
        unit: 'μg/m³'
      }
    ],
    ProjectList: null,
    projectName: null,
    addDevState: false,
    proAreaList: null,
    proDevNum1: null,
    proDevNum: null,
    whitchArea: '',
    areaLog: null,
    AreaID: null,
    AreaName: null,
    projectID: null,
    areaInfoFirst: {
      dev_detail: {}
    },
    areaInfo: {
      dev_detail: {}
    },
    deviceList: null,
    deviceLog: null,
    File: null,
    projectDev: null,
    deviceLogList: null,
    ipDeviceList: null,
    devPage: null,
    brandList: null,
    Cityaqi: null,
    XF: 0,
    smartstatus: null
  },
  mutations: {
    setDb (state, value) {
      state.showDb = value
    },
    setAir (state, value) {
      state.isAir = value
    },
    setLang (state, value) {
      state.isChina = value
    },
    clearXF (state) {
      state.XF = 0
    },
    setU (state, data) {
      state.U = data
    },
    // 设置用户
    setUser (state, data) {
      state.user = data
    },
    // 设置项目列表
    setProjectList (state, data) {
      state.ProjectList = data
    },
    // 设置项目名
    setProjectName (state, id) {
      state.projectID = id
      if (state.ProjectList) {
        state.ProjectList.forEach(item => {
          if (parseInt(item.id) === parseInt(id)) {
            state.projectName = item.name
          }
        })
      }
    },
    // 设置状态
    setDevState (state) {
      state.addDevState = !state.addDevState
    },
    // 设置项目区域列表
    setProAreaList (state, data) {
      state.proAreaList = data
    },
    // 设置区域第一个
    setAreaInfoFirst (state, data) {
      state.areaInfoFirst = data
    },
    // 设置场所详情
    setAreaInfo (state, data) {
      if (data) {
        state.areaInfo = null
        state.areaInfo = data
      }
    },
    // 设置设备列表
    setDeviceList (state, data) {
      state.deviceList = data
    },
    // 设置设备数据
    setDeviceLog (state, data) {
      state.deviceLog = data
    },
    setFile (state) {
      if (state.File) {
        state.File = null
      } else {
        state.File = 1
      }
    },
    setProjectDev (state, data) {
      state.projectDev = data
    },
    setProDevNum (state, data) {
      state.proDevNum = parseInt(data.total_count)
    },
    setProDevNum1 (state, data) {
      state.proDevNum1 = parseInt(data.total_count)
    },
    setAreaDev (state, name) {
      state.whitchArea = name
    },
    setDeviceLogList (state, data) {
      state.deviceLog = {}
      state.deviceLogList = data
    },
    setIpDeviceList (state, data) {
      state.ipDeviceList = data
    },
    setAreaLog (state, data) {
      state.areaLog = null
      state.areaLog = data
    },
    setAreaId (state, id) {
      state.AreaID = id
    },
    setAreaName (state, name) {
      state.AreaName = name
    },
    setDevicePage (state, data) {
      state.devPage = data.total_count
    },
    setDevicebrand (state, data) {
      state.brandList = data
    },
    setCityaqi (state, data) {
      if (state.Cityaqi) {
        state.Cityaqi = null
        state.Cityaqi = JSON.parse(data[0].aqiForecast)
      } else {
        state.Cityaqi = JSON.parse(data[0].aqiForecast)
      }
    },
    setXF (state, data) {
      state.XF = parseInt(data)
    },
    setsmartstatus (state, data) {
      state.smartstatus = data
    }
  },
  actions: {
    // 登录
    async login ({ commit }, str) {
      try {
        var res = await Login(str)
        commit('setUser', res.data)
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取项目列表
    async getProjectList ({ commit }, str) {
      try {
        var res = await GetProjectList(str)
        commit('setProjectList', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    // 刷洗token
    async refreshToken ({ commit }, str) {
      try {
        var res = await reToken(str)
        window.localStorage.setItem('token', res.data.data.token)
        window.localStorage.setItem('retoken', res.data.data.refresh_token)
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取区域列表
    async getProAreaList ({ commit }, str) {
      try {
        var res = await ProAreaList(str)
        commit('setProAreaList', res.data.data)
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取区域第一个
    async getAreaInfoFirst ({ commit }, str) {
      try {
        var res = await AreaInfoFirst(str)
        commit('setAreaInfoFirst', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取场所详情
    async getAreaInfo ({ commit }, str) {
      try {
        var res = await AreaInfo(str)
        commit('setAreaInfo', res.data.data)
        return res.data.data
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取设备列表
    async getDeviceList ({ commit }, str) {
      try {
        var res = await DeviceList(str)
        commit('setDeviceList', res.data.data)
        commit('setProDevNum1', res.data.meta)
        return res.data.data
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取设备数据
    async getDeviceLog ({ commit }, str) {
      try {
        var res = await DeviceLog(str)
        commit('setDeviceLog', res.data.data)
        return res.data.data
      } catch (e) {
        throw new Error(e)
      }
    },
    // 添加地区
    async addArea ({ commit }, str) {
      try {
        var res = await Area(str)
        commit('setFile')
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 编辑地区
    async editArea ({ commit }, str) {
      try {
        var res = await EArea(str)
        commit('setFile')
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 删除地区
    async delArea ({ commit }, str) {
      try {
        var res = await DArea(str)
        commit('setFile')
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取项目设备
    async getProjectDev ({ commit }, str) {
      try {
        var res = await ProjectDev(str)
        commit('setProjectDev', res.data.data)
        commit('setProDevNum', res.data.meta)
      } catch (e) {
        throw new Error(e)
      }
    },
    // 添加设备
    async addDevice ({ commit }, str) {
      try {
        var res = await addDev(str)
        commit('setFile')
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 编辑设备
    async editDevice ({ commit }, str) {
      try {
        var res = await eDev(str)
        commit('setFile')
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 删除设备
    async delDevice ({ commit }, str) {
      try {
        var res = await delDev(str)
        commit('setFile')
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取设备数据列表
    async getDeviceLogList ({ commit }, str) {
      try {
        var res = await DeviceLogList(str)
        commit('setDeviceLogList', res.data.data)
        commit('setProDevNum', res.data.meta)
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取感知设备
    async getIpDeviceList ({ commit }, str) {
      try {
        var res = await IpDeviceList(str)
        commit('setIpDeviceList', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    // 获取区域数据
    async getAreaLog ({ commit }, str) {
      try {
        var res = await getALog(str)
        commit('setAreaLog', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    async getDevicebrandList ({ commit }, str) {
      try {
        var res = await getDevicebrand(str)
        commit('setDevicebrand', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    async getCityaqi ({ commit }, str) {
      try {
        var res = await getAqi(str)
        commit('setCityaqi', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    async checklog ({ commit }, str) {
      try {
        var res = await download(str)
        return res.data.data
      } catch (e) {
        throw new Error(e)
      }
    },
    async controlxf ({ commit }, str) {
      try {
        var res = await xf(str)
        return res
      } catch (e) {
        throw new Error(e)
      }
    },
    async searchAreaXF ({ commit }, str) {
      try {
        var res = await AreaXF(str)
        commit('setXF', res.data.data.status)
      } catch (e) {
        throw new Error(e)
      }
    },
    async startsmartmodel ({ commit }, str) {
      try {
        var res = await martmodel(str)
        console.log(res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    async getsmartmodel ({ commit }, str) {
      try {
        var res = await smartstatus(str)
        commit('setsmartstatus', res.data.data)
      } catch (e) {
        throw new Error(e)
      }
    },
    async getDeviceType ({ commit }, str) {
      try {
        var res = await DeviceType(str)
        return res.data.data
      } catch (e) {
        throw new Error(e)
      }
    },
    async getDeviceParam ({ commit }, str) {
      try {
        var res = await DeviceParam(str)
        return res.data.data
      } catch (e) {
        throw new Error(e)
      }
    }
  }
}
export default module1
